<template>
  <div class="client-card">
    <WdsStack justify-space-between align-center gap-sm class="client-card__header">
      <WdsHeading class="tw-pl-1 tw-text-lg" type="title3">{{ title }}</WdsHeading>
      <slot name="action" />
    </WdsStack>

    <template v-if="loading">
      <div v-if="loadingTiles > 0" class="client-card__tiles">
        <WdsStack justify-space-between gap-sm>
          <div v-for="tile in loadingTiles" :key="tile" class="client-card__tile-skeleton" />
        </WdsStack>
      </div>
      <div class="client-card__body">
        <LoadingList :count="3" no-bg />
      </div>
    </template>
    <template v-else>
      <!-- Tiles sit outside the padded body so they span the card, like the header. -->
      <div v-if="$slots.tiles" class="client-card__tiles">
        <slot name="tiles" />
      </div>
      <div v-if="$slots.default" class="client-card__body">
        <slot />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { WdsHeading, WdsStack } from '@worksome/wds-components'
import LoadingList from '@/components/Dashboard/Widgets/Utils/LoadingList.vue'

withDefaults(
  defineProps<{
    title: string
    loading?: boolean
    /** How many tile placeholders the skeleton shows, so it matches the loaded card. */
    loadingTiles?: number
  }>(),
  { loadingTiles: 3 },
)
</script>

<style scoped lang="scss">
.client-card {
  @apply tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white;
}

.client-card__header {
  @apply tw-border-b tw-border-gray-200 tw-bg-true-gray-50 tw-px-4 tw-py-2;
}

.client-card__tiles {
  @apply tw-pt-2;
}

.client-card__body {
  @apply tw-p-4;
}

.client-card__tile-skeleton {
  @apply tw-h-[74px] tw-flex-1 tw-basis-0 tw-animate-pulse tw-rounded tw-bg-gray-200;
}
</style>
